"use client";

import { useEffect } from "react";

import {
  SESSION_LOGIN_CHANNEL,
  isSessionLoginMessage,
} from "@/utils/sessionLogin";

// Installed on the UNAUTHENTICATED (auth) layout only. When a sibling tab
// signs in, this tab reloads: the new session cookie is already in the
// browser, so the server-side gate on the (auth) layout redirects it straight
// to the role's home page. A plain reload (not a client navigation) is used
// for the same reason the logout side uses a full navigation — the next
// request must be fresh SSR against the new cookie, with no stale client
// state carried over.
//
// Own-echo filtering is unnecessary here: the publishing tab is already
// navigating away, and even a reload of it would land on the same page.
export const useSessionLoginListener = (): void => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (typeof BroadcastChannel === "undefined") return;

    const channel = new BroadcastChannel(SESSION_LOGIN_CHANNEL);

    const handleMessage = (event: MessageEvent) => {
      if (!isSessionLoginMessage(event.data)) {
        // eslint-disable-next-line no-console
        console.warn(
          "[sessionLogin] dropping malformed broadcast message",
          event.data
        );
        return;
      }
      window.location.reload();
    };

    channel.addEventListener("message", handleMessage);
    return () => {
      channel.removeEventListener("message", handleMessage);
      channel.close();
    };
  }, []);
};
